import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';

import { COMPARABLE_REDUCER } from '../../../../redux/ReducerNames';

import ScrollableContainer from '../../../utility/ScrollableContainer';
import ComparableArea from '../common/searcharea/SearchArea';
import ComparableCriteria from '../common/searcharea/Criteria';
import ComparableActions from './ComparableActions';

class Comparable extends React.Component {
    static propTypes = {
        classes: PropTypes.object.isRequired
    };

    constructor (props) {
        super(props);
        console.warn('Backend set layer to config not hard coded');
    }

    render () {
        const { classes } =this.props;
        return (
            <>
                <ScrollableContainer className={classes.root}>
                    <ComparableArea
                        reducerName={COMPARABLE_REDUCER}
                        reducerAreaKey="comparableArea"
                        featureKey="comparable"
                        heading="1. Define your comparable area"
                    />
                    <div className={classes.border} />
                    <ComparableCriteria
                        reducerName={COMPARABLE_REDUCER}
                        reducerAreaKey="comparableArea"
                        heading="2. Choose your comparable criteria"
                        layerId={346}
                    />
                </ScrollableContainer>
                <div className={classes.border} />
                <div className={classes.root}>
                    <ComparableActions />
                </div>

            </>
        );
    }
}

const style = theme => ({
    root: {
        padding: theme.constants.spacing.xl,
        '&> *:not(:last-child)':{
            marginBottom: theme.constants.verticalMargin
        }
    },
    border: {
        height: '2px',
        backgroundColor: theme.palette.background.border
    }
});

export default withStyles(style)(Comparable);